import { Factory } from '../Factory';

namespace app.services.auditing {
  import ITimeoutService = angular.ITimeoutService;

  export interface IAuditLogParams extends IParams {
    page: number;
    limit: number;
    sortOperations: Array<SortOperation>;
  }

  export class AuditLogService implements IService {
    private ItemResource;

    constructor(rootScope: IRootScope, $resource: angular.resource.IResourceService, $timeout: ITimeoutService, private configService: app.services.IConfigService, resourceWrapperService: app.services.utilities.ResourceWrapperService, private httpService: app.services.IHttpWrapperService, notificationService: app.services.INotificationService) {
      $timeout(() => {
        const auditResource = $resource(`${configService.getServerBaseUrlForResource()}/auditing/project/:projectId`,
          {projectId: "@projectId"},
          {
            query: {method: "POST", params: {page: 1, limit: 50}}
          });

        this.ItemResource = resourceWrapperService.WrapActions(auditResource);
      });

      rootScope.$on("FeedService.AuditLogDownloadComplete", (event, message) => {
        notificationService.addSuccess({
          title: "Download Complete",
          description: `The audit log CSV is available for download`,
          buttons: `<a class="btn btn-success" href="${message.directDownloadPath}"><i class="icon-download-alt"></i> Download</a>`,
          timeout: 5000
        });
      });
    }

    public async FindAll(params: IAuditLogParams) {
      return this.ItemResource.query({
        projectId: params.projectId,
        page: params.page,
        limit: params.limit
      }, params.sortOperations).$promise;
    }

    public Audit(projectId, description: string, data) {
      this.httpService?.$http({
        method: 'POST',
        url: `${this.configService.getServerBaseUrl()}/auditing/project/${projectId}/description/${description}`,
        data: data
      });
    }

    public GetCSV(projectId: string) {
      let url = `${this.configService.getServerBaseUrl()}/auditing/csv/project/${projectId}`;

      return this.httpService.$http({
        method: 'GET',
        url: url
      });
    }
  }

  frontendApp.factory("AuditLogService", ["$rootScope", "$resource", "$timeout", "ConfigService", "ResourceWrapperService", "HttpService", "NotificationService", Factory.Create(AuditLogService)]);
}
